import styled from "styled-components";

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  padding: 16px;
  transition: all 0.3s ease-in-out;
  opacity: ${(props) => (props.$isAnimating ? 1 : 0)};
`;

export const ModalContainer = styled.div`
  width: 100%;

  position: absolute;
  top: 50%;
  left: 50%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  max-height: 90dvh;
  overflow-y: auto;
  width: 100%;
  max-width: 320px;

  opacity: ${({ $isAnimating }) => ($isAnimating ? 1 : 0)};
  transform: ${({ $isAnimating }) =>
    $isAnimating
      ? "translate(-50%, -50%) scale(1) translateY(0)"
      : "translate(-50%, -50%) scale(0.8) translateY(50px)"};
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

  border-radius: 24px;
  border: 1px solid #142743;
  background: #0b1727;

  @media (max-width: 768px) {
    max-width: 375px;
  }
  @media (max-width: 475px) {
    max-width: calc(100% - 32px);
  }
`;

export const ChevronButton = styled.div`
  position: absolute;
  top: 24.36px;
  left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 24px;
  height: 24px;
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`;
export const Label = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;
export const InputContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
`;
export const InvisibleDiv = styled.div`
  opacity: 0;
  pointer-events: none;
  user-select: none;
  width: 100%;
  height: 35px;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const CloseButton = styled.button`
  margin-left: auto;
  background: transparent;
  border: none;
  color: white;
  min-width: 24px;
  max-width: 24px;
  min-height: 24px;
  max-height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s ease;
  z-index: 10;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;
export const ModalTitle = styled.h2`
  color: #fff;
  font-family: Figtree;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: -0.09px;
`;

export const ModalSubtitle = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

export const LoginIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const EmailSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  transition: all 0.3s ease;
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  display: flex;
  /* max-width: 240px; */
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  &:focus {
    border-color: #2877D9;
  }
`;
export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 8px;
  justify-content: center;
`;
export const Button = styled.button`
  display: flex;
  width: 100%;
  height: 42px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: #fff;
  border: none;
  outline: none;

  color: #081120;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const GoogleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;

  padding-right: 13.2px;

  height: 42px;
  border-radius: 100px;
  border: 1px solid #dadce0;
  background: #fff;
  color: #3c4043;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  transition: background 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: #f8f9fa;
    box-shadow: 0 1px 3px rgba(60, 64, 67, 0.3);
  }

  &:active {
    background: #f1f3f4;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
  }
`;

export const FlipCardInner = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  text-align: center;
  transition: transform 0.6s;
  transform-style: preserve-3d;
  transform: ${(props) =>
    props.$isFlipped ? "rotateY(180deg)" : "rotateY(0deg)"};
`;

export const FlipCardFront = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const FlipCardBack = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  transform: rotateY(180deg);
`;

export const ToggleText = styled.p`
  text-align: center;
  margin-top: 20px;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.6)" : "rgba(255, 255, 255, 0.6)"};
  font-size: 14px;
  transition: opacity 0.3s ease;
`;

export const VerificationMessage = styled.div`
  text-align: center;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 8px;

  p {
    color: #fff;
    text-align: center;
    font-family: Figtree;
    font-size: 14px;
    font-weight: 300;
    letter-spacing: -0.21px;
  }

  strong {
    color: #2877D9;
    font-weight: 600;
  }
`;

export const ResendButton = styled.span`
  color: #2877D9;

  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  text-align: center;
  font-family: Figtree;
  font-size: 14px;
  letter-spacing: -0.21px;

  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`;

export const LoginOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const LoginOption = styled.div`
  width: 100%;
`;

export const LoginButton = styled.button`
  width: 100%;
  background: ${({ theme, $variant }) => {
    if ($variant === "google") {
      return theme === "light" ? "#fff" : "#2d3748";
    }
    if ($variant === "github") {
      return theme === "light" ? "#24292e" : "#24292e";
    }
    if ($variant === "discord") {
      return "#5865F2";
    }
    return theme === "light"
      ? "rgba(0, 0, 0, 0.03)"
      : "rgba(255, 255, 255, 0.05)";
  }};
  color: ${({ theme, $variant }) => {
    if ($variant === "google") {
      return theme === "light" ? "#1a1a1a" : "#fff";
    }
    if ($variant === "github") {
      return "#fff";
    }
    if ($variant === "discord") {
      return "#fff";
    }
    return theme === "light" ? "#1a1a1a" : "#fff";
  }};
  border: ${({ theme, $variant }) => {
    if ($variant === "google") {
      return theme === "light" ? "2px solid #dadce0" : "2px solid #5f6368";
    }
    return "none";
  }};
  padding: 16px 24px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ $variant }) => {
      if ($variant === "google") {
        return "0 8px 25px rgba(66, 133, 244, 0.2)";
      }
      if ($variant === "github") {
        return "0 8px 25px rgba(36, 41, 46, 0.3)";
      }
      if ($variant === "discord") {
        return "0 8px 25px rgba(88, 101, 242, 0.3)";
      }
      return "0 8px 25px rgba(0, 0, 0, 0.1)";
    }};
    background: ${({ theme, $variant }) => {
      if ($variant === "google") {
        return theme === "light" ? "#f8f9fa" : "#374151";
      }
      if ($variant === "github") {
        return "#2f363d";
      }
      if ($variant === "discord") {
        return "#4752c4";
      }
      return theme === "light"
        ? "rgba(0, 0, 0, 0.05)"
        : "rgba(255, 255, 255, 0.08)";
    }};
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Divider = styled.div`
  position: relative;
  text-align: center;
  margin: 32px 0;

  &::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.1)" : "rgba(255, 255, 255, 0.1)"};
  }
`;

export const DividerText = styled.span`
  background: ${({ theme }) => (theme === "light" ? "#f8f9fa" : "#152a47")};
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.5)"};
  padding: 0 20px;
  font-size: 14px;
  font-weight: 500;
`;

export const PasswordInputContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const PasswordToggle = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: ${({ theme }) =>
    theme === "light" ? "rgba(0, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.5)"};
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s ease;

  &:hover {
    color: ${({ theme }) =>
      theme === "light" ? "rgba(0, 0, 0, 0.7)" : "rgba(255, 255, 255, 0.7)"};
  }
`;

export const CodeInputContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 32px;
`;
export const ResendContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-direction: row;
  margin-top: 12px;
`;

export const CodeInput = styled.input`
  padding: 0;

  text-align: center;
  transition: all 0.3s ease;
  outline: none;
  box-sizing: border-box;
  /* caret-color: #2877D9; */
  caret-color: #fff;

  display: flex;
  width: 32px;
  height: 44px;
  justify-content: space-between;
  align-items: center;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  /* Remove spinner buttons for number input */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  &[type="number"] {
    -moz-appearance: textfield;
  }

  &:focus {
    border-color: #2877D9;
    background: rgba(255, 255, 255, 0.08);
  }

  @media (max-width: 480px) {
    width: 42px;
    height: 50px;
    font-size: 20px;
    gap: 6px;
  }
`;
export const ReferralLinkContainer = styled.div`
  display: flex;

  align-items: center;
  gap: 16px;
`;

export const LightText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.08px;
  opacity: 0.2;
`;

export const ReferralLink = styled.div`
  flex: 1;
  padding: 12px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  font-family: Figtree;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;
  max-width: 229px;
  span {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const CopyButton = styled.button`
  cursor: pointer;
  transition: all 0.3s ease;
  justify-content: center;
  font-family: Figtree;
  border: none;
  outline: none;

  display: flex;
  height: 44px;
  padding: 9px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;

  border-radius: 100px;
  background: #fff;

  &:hover:not(:disabled) {
    transform: translateY(-1px);
  }

  @media (max-width: 450px) {
    align-self: flex-end;
  }
`;
